import {Styler} from 'stylefire';

export type GetPropStylerFunc = (propName:string) => Styler;
export type GetPropPathFunc = (propName:string) => string;

export enum AnimateProperty
{
    BackgroundColor = 'backgroundColor',
    BackgroundOpacity = 'backgroundOpacity',
    BorderColor = 'borderColor',
    BorderOpacity = 'borderOpacity',
    Color = 'color',
    Blur = 'blur',
    BackgroundBlur = 'backgroundBlur'
}

export enum AnimateRelatedProperty
{
    BackgroundVisibility = 'backgroundVisibility',
    BackgroundType = 'backgroundType',
    BorderVisibility = 'borderVisibility',
    BlurEnabled = 'blurEnabled',
    BackgroundBlurEnabled = 'backgroundBlurEnabled'
}

export interface IAnimationProps
{
    readonly registerPropStylerFunc:(getStylerFunc:GetPropStylerFunc) => void;
    readonly registerPropPathFunc:(getPropPathFunc:GetPropPathFunc) => void;
}
